// extracted by mini-css-extract-plugin
module.exports = {"overlay":"wh","bodyOpen":"xh","content":"yh","header":"zh","close":"Ah","closeNoHeading":"Bh"};